import { render, staticRenderFns } from "./salInsuredList.vue?vue&type=template&id=d9b0a252&scoped=true&"
import script from "./salInsuredList.vue?vue&type=script&lang=js&"
export * from "./salInsuredList.vue?vue&type=script&lang=js&"
import style0 from "./salInsuredList.vue?vue&type=style&index=0&id=d9b0a252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b0a252",
  null
  
)

export default component.exports